import script from "./ChatPlanBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPlanBadge.vue?vue&type=script&setup=true&lang=js"

import "./ChatPlanBadge.vue?vue&type=style&index=0&id=2f0bbd60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0bbd60"]])

export default __exports__